import {OpenTraderReportsDialog} from "./OpenTraderReportsDialog";
import {otReportDialog, OTReportDialog} from "./component/OpenTraderReportDialogComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.dialog`;

    return angular.module(moduleName, [])
                  .component(OTReportDialog, otReportDialog())
                  .service(OpenTraderReportsDialog.id, OpenTraderReportsDialog)
                  .name;
}
